module.exports = __webpack_public_path__ + "static/media/ckn_usuarios.d41abd24.jpg";